// Frontend/pages/MaintenanceHead.js
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./MaintenanceHead.css";
import { LogoutButton } from "../Common/LogoutButton";
import { jwtDecode } from "jwt-decode"; // npm install jwt-decode

const MaintenanceHead = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [isAdmin, setIsAdmin] = useState(false);
  const [showBackButton, setShowBackButton] = useState(false);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");

    if (!storedUser) {
      navigate("/signin", { replace: true });
      return;
    }

    try {
      const parsedUser = JSON.parse(storedUser);
      const token = parsedUser?.jwt_token;

      if (!token) {
        throw new Error("No token found");
      }

      // ✅ Decode JWT
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000;

      // ✅ Expiry check
      if (decoded.exp && decoded.exp < currentTime) {
        console.warn("JWT expired, redirecting to signin");
        localStorage.removeItem("user");
        navigate("/signin", { replace: true });
        return;
      }

      // console.log("Decoded JWT:", decoded);

      // ✅ Role check
      const isAdminUser = decoded.role === "admin";
      setIsAdmin(isAdminUser);

      // ✅ Back button logic
      const adminFromRequester = sessionStorage.getItem("adminFromRequester");
      if (
        isAdminUser &&
        (location.state?.fromAdmin || adminFromRequester === "true")
      ) {
        setShowBackButton(true);
        sessionStorage.setItem("adminFromRequester", "true");
      }
    } catch (err) {
      console.error("Invalid token:", err);
      localStorage.removeItem("user");
      navigate("/signin", { replace: true });
    }
  }, [navigate, location]);

  const handleBackClick = () => {
    sessionStorage.removeItem("adminFromRequester");
    navigate("/requester");
  };

  return (
    <div
      className="maintenance-head-container"
      style={{ position: "relative" }}
    >
      {/* Back button (only if admin came from requester) */}
      {showBackButton && (
        <button onClick={handleBackClick} className="back-btn">
          ← Back
        </button>
      )}

      {/* Logout button */}
      <div className="logout-btn">
        <LogoutButton />
      </div>

      <h1 className="dashboard-title">Maintenance Head Dashboard</h1>

      <div className="card-container">
        {/* Requests */}
        <div className="card" onClick={() => navigate("/requests")}>
          <h2 className="card-heading">REQUESTS</h2>
          <div className="card-icon">🛠️</div>
          <h3 className="card-title">Requests</h3>
          <p className="card-description">
            Check and manage maintenance requests.
          </p>
        </div>

        {/* Ride Reports */}
        <div className="card" onClick={() => navigate("/ride-reports")}>
          <h2 className="card-heading">RIDE REPORTS</h2>
          <div className="card-icon">🚗</div>
          <h3 className="card-title">Ride Reports</h3>
          <p className="card-description">
            Monitor and review ride activity and performance.
          </p>
        </div>

        {/* Driver Info (Admin only) */}
        {isAdmin && (
          <div className="card" onClick={() => navigate("/driver-info")}>
            <h2 className="card-heading">DRIVER-INFO</h2>
            <div className="card-icon">👷</div>
            <h3 className="card-title">Driver Info</h3>
            <p className="card-description">
              View and update driver and vehicle information.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MaintenanceHead;
